import type { Router, RouterSlice } from './app-state.js';

export const getRouter = (state: RouterSlice): Router => state.router;
